module.exports = __webpack_public_path__ + "img/b013_1.a507d649.jpeg";